import React, {useState, useEffect, useRef} from 'react';
import {Form, Table} from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import { useTakeTheLead } from "hooks/actives/take-the-lead";
import { DEFAULT_PAGE_INFO } from "consts";
import emiter, { _EVENTS } from "../../../../events";
import EnumKeyToText from "../../../product-price/base/EnumKeyToText";
import SPTableActionBar from '../table-action-bar';


interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface IValueAddedPriceTableDataType {
    key?: any;
    id?: any;
    name?: any;
    state?: any;
    createDate?: any;
    [key: string]: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  const columns: TableProps<IValueAddedPriceTableDataType>['columns'] = [
    // { title: '供应商名称', dataIndex: 'supplier_name', key: 'supplier_name' },
    { title: '折扣上限', width: 150, dataIndex: 'discount', key: 'discount' },
    { title: '活动ID', width: 100, dataIndex: 'grab_top_code', key: 'grab_top_code' },
    { title: '参与门店/总门店', width: 150, dataIndex: 'name', key: 'name', render: (_, record) => (
      <>
        {record.participate_store_count}/{record.total_store_count}
      </>
      ) },
    { title: '参与车型商品/总商品', width: 150, dataIndex: 'name', key: 'name', render: (_, record) => (
        <>
          {record.participate_price_mod_count}/{record.total_price_mod_count}
        </>
      ) },
    { title: '状态', width: 150, dataIndex: 'name', key: 'name', render: (_, record) => <EnumKeyToText data={record} enums={enums} valueKey={'status'} nameSpace={'act_reg_status'} />},
    { title: '操作', width: 150, dataIndex: 'name', key: 'name', render: (_, record) => (
        <SPTableActionBar data={record} permission={permission}></SPTableActionBar>
      ) },
  ];

  const [data, setData] = useState<any>([]);


  const dataRef = useRef({});

  const { search } = useTakeTheLead();

  const load = (params?: any) => {
      params = Object.assign({...DEFAULT_PAGE_INFO}, {...dataRef.current}, params);
      search({}).then((data: any) => {
          const res = data?.data
          setData(res || []);
          dataRef.current = params
      })
  };



  useEffect(() => {
    emiter.on(_EVENTS.ACTIVES.TAKE_THE_LEAD.SEARCH, load);
    setTimeout(() => {
      emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.SEARCH);
    })
    return () => {
        emiter.removeAllListeners(_EVENTS.ACTIVES.TAKE_THE_LEAD.SEARCH)
    }
  }, []);

  return <Table
    size='middle'
    scroll={{ x: '100%' }}
    columns={columns}
    dataSource={data}
    rowKey={cols => cols.id}
    pagination={false}
  />
};

export default SPTable;

